import * as React from 'react';
import { useState , useEffect} from 'react';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import { Container, Row, Col, Label } from 'reactstrap';
import { DocumentError, getErrors, resetError } from '../../../redux/DocumentsSlice';

import './ModalPopUp.css';
import Modal from './Modal';



const DisplaySliceErrors = (props: any) => {

    const dispatch = useAppDispatch();
    /* */
    const errors: DocumentError = useAppSelector(getErrors);

    const [isOpen, setIsOpen] = useState(false);


    const handleClose = function (e: any) {

        /* remove error once seen */
        dispatch(resetError({}));

        /* close modal */
        setIsOpen(false);

    }

    useEffect(function () {
        if (errors) {
            setIsOpen(true);
        }
    }, [errors]);


    function renderError() {

        return (
            <React.Fragment>

                <Container>
                    <Row xs="1">
                        <Col>
                            <p>
                                {errors && errors.message}
                            </p>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <p>
                                {errors && errors.content}
                            </p>
                        </Col>
                    </Row>
                    <Row xs="1">
                        <Col>
                            <p>
                                {errors && errors.stackTrace}
                            </p>
                        </Col>
                    </Row>
                    <br />
                </Container>
            </React.Fragment >
        );
    }

    const renderModal = renderError();

    return (
        <React.Fragment >
            <Modal isOpen={isOpen} onClose={handleClose}>
                <div className="ModalPopUp">
                    <h4>Errors</h4>
                    <br />
                    <br />
                    <div style={{ height: "35em", overflowY: "auto", width: "34em" }}>
                        {isOpen && renderModal}
                    </div>
                    <div>
                        <button onClick={handleClose} className="btn btn-primary">
                            Close
                        </button>
                        </div>
                    </div>
            </Modal>
        </React.Fragment >
    );
}

export default DisplaySliceErrors;